import { gql } from '@biletiniz/apollo';

export const TOKEN = gql`
  mutation token($refreshToken: String!) {
    token(refreshToken: $refreshToken) {
      message
      token {
        accessToken
        accessTokenExpiresAt
        refreshToken
        refreshTokenExpiresAt
        user {
          name
          surname
          email
          phoneNumber
          balance {
            amount
            currency
          }
        }
      }
    }
  }
`;
